/** Production-captured performance overview from Ads Manager (Figma / Chromatic reference). */
export const PRODUCTION_PERFORMANCE_OVERVIEW_IMAGE =
  "https://cdn.prerelease.faire.dev/fastly/fade7652e60b5888aa9fdc012746fb59cfb2e544f34d30e1ed07d9d4d9c17848.png";

export const PERFORMANCE_DATE_RANGE = "Jun 12, 2025 – May 31, 2026";

/** Pixels to clip from the top of the overview screenshot (header row is built in JSX). */
export const OVERVIEW_IMAGE_HEADER_CLIP_PX = 88;

export const ADS_MANAGER_TABS = [
  { value: "overview", label: "Overview" },
  { value: "new-customers", label: "New customers" },
  { value: "returning-customers", label: "Returning customers" },
  { value: "advertised-products", label: "Advertised products" },
] as const;
